'use client'
import Link from 'next/link'
import type { ComponentProps } from 'react'
import posthog from 'posthog-js'
import { startNewTrace } from '@/lib/trace-context'
import { markTracedLinkFired } from './posthog-pageview'

/**
 * Drop-in replacement for Next.js `Link` that starts a new trace on click.
 * This ensures the nav_click PostHog event and the resulting $pageview share
 * the same traceId, enabling end-to-end correlation from click → API logs.
 */
export function TracedLink({ onClick, href, ...props }: ComponentProps<typeof Link>) {
  return (
    <Link
      href={href}
      onClick={(e) => {
        const traceId = startNewTrace()
        posthog.register({ traceId })
        markTracedLinkFired()
        try {
          posthog.capture('nav_click', { destination: href.toString(), traceId })
        } catch {
          // non-fatal
        }
        onClick?.(e)
      }}
      {...props}
    />
  )
}
